<template>
  <div
    class="bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[120px] xl:py-[135px]"
  >
    <div
      class="mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]"
    >
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center">
        <div
          class="xl:ltr:-mr-[25px] xl:rtl:-ml-[25px] 2xl:ltr:-mr-[45px] 2xl:rtl:-ml-[45px] rounded-[25px] order-2 lg:order-1"
        >
          <img
            src="@/assets/images/sign-up.jpg"
            alt="sign-up-image"
            class="rounded-[25px]"
          />
        </div>
        <div
          class="xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] order-1 lg:order-2"
        >
          <img
            src="@/assets/images/logo-big.svg"
            alt="logo"
            class="inline-block dark:hidden"
          />
          <img
            src="@/assets/images/white-logo-big.svg"
            alt="logo"
            class="hidden dark:inline-block"
          />
          <div class="my-[17px] md:my-[25px]">
            <h1
              class="font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[7px]"
            >
              Sign Up to Trezo Dashboard
            </h1>
            <p class="font-medium lg:text-md text-[#445164] dark:text-gray-400">
              Sign Up with social account or enter your details
            </p>
          </div>
          
          <div v-if="errorMessage" class="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
            {{ errorMessage }}
          </div>
          
          <div v-if="successMessage" class="mb-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
            {{ successMessage }}
          </div>
          
          <div
            class="flex items-center justify-between mb-[20px] md:mb-[23px] gap-[12px]"
          >
            <div class="grow">
              <button
                type="button"
                class="block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500"
              >
                <img
                  src="@/assets/images/icons/google.svg"
                  class="inline-block"
                  alt="google"
                />
              </button>
            </div>
            <div class="grow">
              <button
                type="button"
                class="block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500"
              >
                <img
                  src="@/assets/images/icons/facebook2.svg"
                  class="inline-block"
                  alt="google"
                />
              </button>
            </div>
            <div class="grow">
              <button
                type="button"
                class="block text-center w-full rounded-md transition-all py-[8px] md:py-[10.5px] px-[15px] md:px-[25px] text-black dark:text-white border border-[#D6DAE1] bg-white dark:bg-[#0a0e19] dark:border-[#172036] shadow-sm hover:border-primary-500"
              >
                <img
                  src="@/assets/images/icons/apple.svg"
                  class="inline-block"
                  alt="google"
                />
              </button>
            </div>
          </div>
          <div class="mb-[15px] relative">
            <label
              class="mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block"
            >
              Full Name
            </label>
            <input
              v-model="fullName"
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Enter your full name"
            />
          </div>
          <div class="mb-[15px] relative">
            <label
              class="mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block"
            >
              Email Address
            </label>
            <input
              v-model="email"
              type="email"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="example@clickai.live"
            />
          </div>
          <div class="mb-[15px] relative" id="passwordHideShow">
            <label
              class="mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block"
            >
              Password
            </label>
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              id="password"
              placeholder="Type password"
            />
            <button
              class="absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[12px] transition-all hover:text-primary-500"
              @click="togglePassword"
              type="button"
            >
              <i :class="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
            </button>
          </div>
          <button
            @click="handleSignUp"
            :disabled="isLoading"
            type="submit"
            class="md:text-md block w-full text-center transition-all rounded-md font-medium my-[20px] md:my-[25px] py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <span class="flex items-center justify-center gap-[5px]">
              <i v-if="!isLoading" class="material-symbols-outlined"> person_4 </i>
              <span v-if="isLoading" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              {{ isLoading ? 'Signing Up...' : 'Sign Up' }}
            </span>
          </button>
          <p class="leading-[1.6]">
            By confirming your email, you agree to our
            <a
              href="#"
              class="font-medium text-black dark:text-white transition-all hover:text-primary-500"
            >
              Terms of Service
            </a>
            and that you have read and understood our
            <a
              href="#"
              class="font-medium text-black dark:text-white transition-all hover:text-primary-500"
            >
              Privacy Policy
            </a>
          </p>
          <p class="leading-[1.6]">
            Already have an account.
            <RouterLink
              to="/authentication/sign-in"
              class="text-primary-500 transition-all font-semibold hover:underline"
            >
              Sign In
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { authService, profileService, organizationService, supabase } from "@/utils/supabase";

export default defineComponent({
  name: "SignUp",
  setup() {
    const router = useRouter();
    const fullName = ref("");
    const email = ref("");
    const password = ref("");
    const showPassword = ref(false);
    const isLoading = ref(false);
    const errorMessage = ref("");
    const successMessage = ref("");

    const togglePassword = () => {
      showPassword.value = !showPassword.value;
    };

    const handleSignUp = async () => {
      // וידוא תקינות הטופס
      if (!fullName.value || !email.value || !password.value) {
        errorMessage.value = "Please fill in all fields";
        return;
      }

      if (password.value.length < 6) {
        errorMessage.value = "Password must be at least 6 characters long";
        return;
      }

      isLoading.value = true;
      errorMessage.value = "";
      successMessage.value = "";

      try {
        // הרשמה עם Supabase
        const { data, error } = await authService.register(email.value, password.value);
        
        if (error) throw error;

        // אם ההרשמה הצליחה, יצירת פרופיל משתמש
        if (data.user) {
          // יש לשים לב - ייתכן שיהיה צורך באימות מייל לפני שניתן ליצור פרופיל
          // במקרה כזה, אפשר להציג הודעה למשתמש לאמת את המייל שלו

          try {
            // יצירת פרופיל משתמש בסיסי
            const { data: profileData, error: profileError } = await supabase
              .from('user_profiles')
              .insert({
                user_id: data.user.id,
                display_name: fullName.value,
                role: 'admin', // משתמש ראשון מקבל תפקיד של מנהל
                permissions_json: {
                  view_all_leads: true,
                  edit_all_leads: true,
                  can_invite_users: true
                }
              })
              .select()
              .single();

            if (profileError) throw profileError;

            successMessage.value = "Registration successful! Please check your email for confirmation.";
            
            // החלטה אם לנתב את המשתמש לדף הראשי או לדף יצירת ארגון
            // במקרה הזה, ננתב ליצירת ארגון אחרי שהמשתמש אימת את המייל שלו
            
            // אם אין צורך באימות מייל, נוכל לנתב ישירות:
            // router.push('/organization/create');
          } catch (profileErr: any) {
            console.error("Profile creation error:", profileErr);
            errorMessage.value = "Registration successful but we couldn't create your profile. Please try signing in.";
          }
        }
      } catch (err: any) {
        console.error("Sign up error:", err);
        errorMessage.value = err.message || "Failed to sign up. Please try again.";
      } finally {
        isLoading.value = false;
      }
    };

    return {
      fullName,
      email,
      password,
      showPassword,
      isLoading,
      errorMessage,
      successMessage,
      togglePassword,
      handleSignUp
    };
  }
});
</script>
